import type { AppBarProps } from '@mui/material/AppBar';
import type { ContainerProps } from '@mui/material/Container';
import type { Breakpoint } from '@mui/material/styles';
import type { ToolbarProps } from '@mui/material/Toolbar';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

// ----------------------------------------------------------------------

export type HeaderSectionProps = AppBarProps & {
  layoutQuery: Breakpoint;
  slots?: {
    leftArea?: React.ReactNode;
    rightArea?: React.ReactNode;
    topArea?: React.ReactNode;
    centerArea?: React.ReactNode;
    bottomArea?: React.ReactNode;
  };
  slotProps?: {
    toolbar?: ToolbarProps;
    container?: ContainerProps;
  };
};

export function HeaderSection({ sx, slots, slotProps, layoutQuery = 'md', ...other }: HeaderSectionProps) {
  const theme = useTheme();

  const toolbarStyles = {
    default: {
      minHeight: 'auto',
      height: 'auto !important',
      transition: theme.transitions.create(['height', 'background-color'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shorter,
      }),
      [theme.breakpoints.up('sm')]: {
        minHeight: 'auto',
      },
      [theme.breakpoints.up(layoutQuery)]: {
        height: '72px',
      },
    },
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        boxShadow: 'none',
        backgroundColor: '#f4efee',
        zIndex: 1100,
        justifyContent: 'center',
        ...sx,
      }}
      {...other}
    >
      {slots?.topArea}

      <Toolbar disableGutters {...slotProps?.toolbar} sx={toolbarStyles}>
        <Container
          {...slotProps?.container}
          sx={{
            height: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {slots?.leftArea}

          <Box sx={{ display: 'flex', flex: '1 1 auto', justifyContent: 'center' }}>{slots?.centerArea}</Box>

          {slots?.rightArea}
        </Container>
      </Toolbar>

      {slots?.bottomArea}
    </AppBar>
  );
}
